(function () {
    'use strict';

    /**
     * @ngdoc object
     * 
     *
     * @description
     *
     */
    angular
        .module('missingSignIn')
        .controller('SignOutCtrl', SignOutCtrl);

    function SignOutCtrl($uibModalInstance,PopupManager, modalParams, MissingSignInService, MessageService,EventManagerService) {
        var vm = this;
        vm.ctrlName = 'SignOutCtrl';
        
        vm.model = {
            signOutData: {
            	crewScheduleBlockId : modalParams.crewScheduleBlockId,
            	signOutDate : modalParams.checkOutDate,
            	signOutTime : modalParams.checkOutTime,
            	comment : null
            }
        };

        vm.doSignOut = function () {
        	MissingSignInService.doSignOut(vm.model.signOutData,
                  function (response) {
                     if (response.success) {
	                    	$uibModalInstance.close();
	                        MessageService.success(MessageService.MESSAGES.CREWING.SUCCESS_SAVE_MESSAGE);
	                		EventManagerService.notifyEventListeners(EventManagerService.EVENT.MISSIN_SIGN_IN.RELOAD_SIGN_OUT_DATA);
	                		openReportActivationWindow(response);
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
         };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };
        
        function openReportActivationWindow(response){
        	
        	if(response.showActivationWindow){
        		var param = {};
    			param.crewScheduleBlockId = response.crewScheduleBlockId;
				PopupManager.openModal('ACTIVATE_FLIGHT_REPORT', param, function(){});
        	}
        }
        
    }
}());
